<template>
  <el-container>
    <el-main style="padding: 0; margin-top: 5px;">
      <!--底部样式-->
      <el-container direction="vertical" style="overflow-x: hidden">
        <el-row>
          <el-col :span="24">
            <div class="list">
              <HeaderBar :title="barTitle"></HeaderBar>
              <div class="list-card">
                <el-table
                  :data="lists"
                  :row-style="rowStyle"
                  :cell-style="cellStyle"
                  :show-header="false"
                  max-height="320px"
                  @row-click="handleRowClickEvent"
                >
                  <el-table-column prop="title" width="" show-overflow-tooltip align="left">
                  </el-table-column>
                  <el-table-column prop="createDate" width="120" align="right"> </el-table-column>
                </el-table>
                <el-divider v-if="totalElements > 10"></el-divider>
                <el-pagination
                  :background="true"
                  layout="prev, pager, next"
                  :total="totalElements"
                  :current-page="pageNo"
                  @current-change="handleSizeChangeEvent"
                  hide-on-single-page
                >
                </el-pagination>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-container>
    </el-main>
  </el-container>
</template>

<script>
import * as dayjs from 'dayjs';
import HeaderBar from '@/components/HeaderBar.vue';
import { prefixedUrlAsset } from '@/utils/constants';

export default {
  name: 'NewsList',
  components: { HeaderBar },
  data() {
    return {
      pageNo: 0,
      pageSize: 10,
      totalElements: 0,
      barTitle: '',
      lists: [],
      menuType: "",
      // 二级分类过滤参数名:政策法规用 policyType,行业资讯用 infoType
      subParam: "policyType"
    };
  },
  watch: {
    $route(to, from) {
      console.log(to.path, from.path);
      console.log('menuType=', this.$route.query.menuType, 'infoType=', this.$route.query.infoType);
      this.barTitle = this.$route.params.name;
      this.initSubParam();

      this.pageNo = 0;
      this.startRequestListApi(this.$route.params.id);
    },
  },
  created() {
    this.barTitle = this.$route.params.name;
    this.initSubParam();
    this.startRequestListApi(this.$route.params.id);
  },
  methods: {
    cellStyle() {
      return 'padding: 0px; font-size:14px; height: 32px; border: none; cursor: pointer;';
    },
    rowStyle() {
      return 'white-space: nowrap;';
    },
    handleSizeChangeEvent(pageNo) {
      console.log(pageNo);
      this.pageNo = pageNo - 1;
      this.startRequestListApi(this.$route.params.id);
    },
    handleRowClickEvent(row) {

      console.log(row);
      this.$router.push({ path: `/detail/${row.id}` });
      //this.$router.push(`/detail/${row.id}`);
  //    console.log(this.$router.)
   // this.$router.go(0);
    },
    initSubParam() {
      // 行业资讯走 infoType,政策法规走 menuType(对应后端 policyType)
      if (this.$route.query.infoType !== undefined) {
        this.menuType = this.$route.query.infoType;
        this.subParam = 'infoType';
      } else if (this.$route.query.menuType !== undefined) {
        this.menuType = this.$route.query.menuType;
        this.subParam = 'policyType';
      } else {
        this.menuType = '';
        this.subParam = 'policyType';
      }
    },
    startRequestListApi(catalogId) {
      this.axios
        .get(
          `${prefixedUrlAsset}/pub/news/list/undertag?catalogId=${catalogId}&${this.subParam}=${this.menuType}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`,
        )
        .then((response) => {
          debugger;
          console.log(response.data);
          this.pageNo = response.data.data.number + 1;
          this.totalElements = response.data.data.totalElements;
          console.log(response.data.data.totalPages);
          if (response.data.data.content) {
            this.lists = response.data.data.content.map((item) => ({
              id: item.id,
              title: item.title,
              createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
            }));
          }
        });
    },
  },
};
</script>

<style lang="scss">
.list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
  padding: 10px 10px 0px 10px;
  margin-bottom: 20px;
  .list-card {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 10px 10px 10px 10px;
    width: 100%;
    background-color: white;
    border-left: 1px solid #DCDCDC;
    border-right: 1px solid #DCDCDC;
    border-bottom: 1px solid #DCDCDC;
    box-sizing: border-box;
    border-radius: 0 0 15px 15px;
  }
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #026D31;
  color: #FFF;
}
</style>
